import config from '../../config'
import TokenService from './token-services'
import IdleService from './idle-services'

const AuthApiService = {
  postLogin(credentials) {
    return fetch(`${config.API_ENDPOINT}/auth/login`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(res =>
        !res.ok ? res.json().then(e => Promise.reject(e)) : res.json()
      )
      .then(res => {
        TokenService.saveAuthToken(res)
        IdleService.registerIdleTimerResets()

        TokenService.queueCallbackBeforeExpiry(() => {
          AuthApiService.postRefreshToken()
        })

        return res
      })
  },
  postUser(user) {
    return fetch(`${config.API_ENDPOINT}/users`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify(user)
    }).then(res => {
      return !res.ok ? res.json().then(e => Promise.reject(e)) : res.json()
    }
    )
  },
  postRefreshToken() {
    return fetch(`${config.API_ENDPOINT}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Authorization': `bearer ${TokenService.getAuthToken()}`
      }
    })
      .then(res => {
        let results = (!res.ok)
          ? res.json().then(e => Promise.reject(e))
          : res.json()

        return results
      }
      )
      .then(res => {
        TokenService.saveAuthToken(res)
        TokenService.queueCallbackBeforeExpiry(() => {
          AuthApiService.postRefreshToken()
        })
        return res
      })
      .catch(err => {
        console.error(err)
      })
  }
}

export default AuthApiService